import React from 'react';
import { Carousel } from 'antd';
import { BannerItem } from '@nxsys/types/models/banner';
import AppBannerCard from '../AppBannerCard';
import { StyledCarouselContainer } from './index.styled';

type AppBannerCarouselProps = {
  banners: BannerItem[];
  onBannerClick?: (banner: BannerItem) => void;
};

const AppBannerCarousel: React.FC<AppBannerCarouselProps> = ({
  banners,
  onBannerClick,
}) => {
  if (banners.length === 0) return null;

  // Single banner - no carousel wrapper needed
  if (banners.length === 1) {
    return (
      <AppBannerCard
        banner={banners[0]}
        onClick={() => onBannerClick?.(banners[0])}
      />
    );
  }

  // Multiple banners - use Ant Design Carousel
  return (
    <StyledCarouselContainer>
      <Carousel autoplay={false} dots={true} infinite={true}>
        {banners.map((banner) => (
          <div key={banner.id}>
            <AppBannerCard
              banner={banner}
              onClick={() => onBannerClick?.(banner)}
            />
          </div>
        ))}
      </Carousel>
    </StyledCarouselContainer>
  );
};

export default AppBannerCarousel;
